import { render, staticRenderFns } from "./TuneupDetail.vue?vue&type=template&id=def8f7c0&scoped=true"
import script from "./TuneupDetail.vue?vue&type=script&lang=js"
export * from "./TuneupDetail.vue?vue&type=script&lang=js"
import style0 from "./TuneupDetail.vue?vue&type=style&index=0&id=def8f7c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8f7c0",
  null
  
)

export default component.exports